import { render, staticRenderFns } from "./EmployeeEdit.vue?vue&type=template&id=2fe0a7ea&"
import script from "./EmployeeEdit.vue?vue&type=script&lang=js&"
export * from "./EmployeeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports